import { type Provider } from 'react';

import type { AgentVersioningConfig } from '../../types';

import { agentVersioningConfigContext } from './agentVersioningConfigContext';

export const AgentVersioningConfigProvider: Provider<AgentVersioningConfig | undefined> =
	agentVersioningConfigContext.Provider;
